import { component } from "picoapp";
import { on, remove, add, has, qs, qsa } from "martha";
import choozy from "choozy";
import Phaser from "phaser";

import { subscribe } from "klaviyo-subscribe";

import Airtable from "airtable";

export default component((node, ctx) => {
  let {
    introScreen,
    killScreen,
    lander,
    container,
    form,
    error,
    errorEmail,
    submit,
    restart,
    userScore,
    leaderboard,
  } = choozy();

  //klaviyo list ID
  const listId = "SsYyQ7";

  let userHighScore;
  let sessionScore;

  //setup game
  var game;
  var gameOptions = {
    // bird gravity, will make bird fall if you dont flap
    birdGravity: 800,

    // horizontal bird speed
    birdSpeed: 115,

    // flap thrust
    birdFlapPower: 300,

    // minimum pipe height, in pixels. Affects hole position
    minPipeHeight: 50,

    // distance range from next pipe, in pixels
    pipeDistance: [220, 280],

    // hole range between pipes, in pixels
    pipeHole: [150, 200],

    // local storage object name
    localHighscore: "highscore",
    currentScore: "currentscore",
  };
  window.onload = function () {
    let gameConfig = {
      type: Phaser.AUTO,
      backgroundColor: 0x87ceeb,
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        parent: container,
        width: 345,
        height: 480,
      },
      pixelArt: true,
      physics: {
        default: "arcade",
        arcade: {
          gravity: {
            y: 0,
          },
        },
      },
      scene: [landingScreen, endScreen, startScreen, playGame],
    };
    game = new Phaser.Game(gameConfig);
    window.focus();
  };

  const isProd = true;

  // https://cdn.shopify.com/s/files/1/0628/2058/1568/files/ground.png?v=1703450091
  // https://cdn.shopify.com/s/files/1/0628/2058/1568/files/sky.png?v=1703275472
  // https://cdn.shopify.com/s/files/1/0628/2058/1568/files/pipe.png?v=1703450532
  // https://cdn.shopify.com/s/files/1/0628/2058/1568/files/player_spritesheet.png?v=1703275273

  const skyData = isProd
    ? "https://cdn.shopify.com/s/files/1/0628/2058/1568/files/sky.png"
    : "../../../assets/sky.png";
  const groundData = isProd
    ? "https://cdn.shopify.com/s/files/1/0628/2058/1568/files/ground.png"
    : "../../../assets/ground.png";
  const pipeData = isProd
    ? "https://cdn.shopify.com/s/files/1/0628/2058/1568/files/pipe.png"
    : "../../../assets/pipe.png";
  const birdData = isProd
    ? "https://cdn.shopify.com/s/files/1/0628/2058/1568/files/player_sprite.png"
    : "../../../assets/player_spritesheet.png";

  class landingScreen extends Phaser.Scene {
    constructor() {
      super("landingScreen");
    }

    preload() {
      this.load.image("sky", skyData);
      this.load.image("ground", groundData);
    }

    create() {
      // Create start screen elements, such as title, play button, etc.

      //sky
      this.add.image(0, 0, "sky").setOrigin(0, 0);

      //ground
      this.ground = this.physics.add
        .sprite(0, game.config.height, "ground")
        .setOrigin(0, 1);

      this.input.on("pointerdown", () => {
        this.scene.start("StartScreen"); // Transition to the main game scene
        ctx.emit("game", { game: "intro" });
        ctx.emit("game:intro");
      });
    }
  }

  class startScreen extends Phaser.Scene {
    constructor() {
      super("StartScreen");
    }

    create() {
      // Create start screen elements, such as title, play button, etc.

      //sky
      this.add.image(0, 0, "sky").setOrigin(0, 0);

      //ground
      this.ground = this.physics.add
        .sprite(0, game.config.height, "ground")
        .setOrigin(0, 1);

      // Add title text dropshadow
      this.add
        .text(game.config.width / 2 - 2, 52, "0", {
          fontFamily: "Super Smash TV",
          fontSize: "54px",
          fill: "#000",
        })
        .setOrigin(0.5);

      // Display a title text
      this.add
        .text(game.config.width / 2, 50, "0", {
          fontFamily: "Super Smash TV",
          fontSize: "54px",
          fill: "#fff",
        })
        .setOrigin(0.5);

      // Add instructions dropshadow
      this.add
        .text(
          game.config.width / 2 - 2,
          game.config.height / 2 + 2,
          "Tap To Jump",
          {
            fontFamily: "Super Smash TV",
            fontSize: "30px",
            fill: "#000",
          }
        )
        .setOrigin(0.5);

      // Add instructions
      this.add
        .text(game.config.width / 2, game.config.height / 2, "Tap To Jump", {
          fontFamily: "Super Smash TV",
          fontSize: "30px",
          fill: "#fff",
        })
        .setOrigin(0.5);

      this.input.on("pointerdown", () => {
        this.scene.start("PlayGame"); // Transition to the main game scene
        ctx.emit("game:started");
        ctx.emit("game", { game: "started" });
      });
    }
  }

  class endScreen extends Phaser.Scene {
    constructor() {
      super("EndScreen");
    }

    create() {
      //sky
      this.add.image(0, 0, "sky").setOrigin(0, 0);

      //ground
      this.ground = this.physics.add
        .sprite(0, game.config.height, "ground")
        .setOrigin(0, 1);
    }
  }

  class playGame extends Phaser.Scene {
    constructor() {
      super("PlayGame");
    }
    preload() {
      this.load.spritesheet("bird", birdData, {
        frameWidth: 57,
        frameHeight: 39,
      });
      this.load.image("pipe", pipeData);
    }
    create() {
      let TO = new Date();
      ctx.hydrate({ to: TO });
      ctx.hydrate({ f: 0 });

      //sky
      this.add.image(0, 0, "sky").setOrigin(0, 0);

      this.anims.create({
        key: "playerAnimation",
        frames: this.anims.generateFrameNumbers("bird", { start: 0, end: 1 }),
        frameRate: 4,
        repeat: -1,
      });
      // Add ground
      // this.ground = this.physics.add
      //   .sprite(0, game.config.height, "ground")
      //   .setOrigin(0, 1);
      // this.physics.add.collider(this.bird, this.ground);
      this.ground = this.physics.add
        .sprite(0, game.config.height, "ground")
        .setOrigin(0, 1);
      this.ground.setVelocityX(-gameOptions.birdSpeed);

      // pipes & bird
      this.pipeGroup = this.physics.add.group();
      this.pipePool = [];
      for (let i = 0; i < 4; i++) {
        this.pipePool.push(this.pipeGroup.create(0, 0, "pipe"));
        this.pipePool.push(this.pipeGroup.create(0, 0, "pipe"));
        this.placePipes(false);
      }
      this.pipeGroup.setVelocityX(-gameOptions.birdSpeed);
      this.bird = this.physics.add.sprite(80, game.config.height / 2, "bird");
      this.bird.body.gravity.y = gameOptions.birdGravity;
      this.input.on("pointerdown", this.flap, this);
      this.score = 0;
      this.topScore = ctx.getState().highscore || 0;
      // score text dropshadow
      this.scoreDrop = this.add
        .text(game.config.width / 2 - 2, 52, "", {
          fontFamily: "Super Smash TV",
          fontSize: "54px",
          fill: "#000",
        })
        .setOrigin(0.5);
      // score text
      this.scoreText = this.add
        .text(game.config.width / 2, 50, "", {
          fontFamily: "Super Smash TV",
          fontSize: "54px",
          fill: "#fff",
        })
        .setOrigin(0.5);
      this.updateScore(this.score);
    }
    updateScore(inc) {
      this.score += inc;

      if (this.score >= this.topScore) {
        this.topScore = this.score;
        ctx.hydrate({ highscore: this.topScore });
      }

      userHighScore = this.score > userHighScore ? this.score : userHighScore;
      sessionScore = this.score

      this.scoreText.text = this.score;
      this.scoreDrop.text = this.score;
      // this.scoreText.text = "Score: " + this.score + "\nBest: " + this.topScore;
    }
    placePipes(addScore) {
      let rightmost = this.getRightmostPipe();
      let pipeHoleHeight = Phaser.Math.Between(
        gameOptions.pipeHole[0],
        gameOptions.pipeHole[1]
      );
      let pipeHolePosition = Phaser.Math.Between(
        gameOptions.minPipeHeight + pipeHoleHeight / 2,
        game.config.height - gameOptions.minPipeHeight - pipeHoleHeight / 2
      );
      this.pipePool[0].x =
        rightmost +
        this.pipePool[0].getBounds().width +
        Phaser.Math.Between(
          gameOptions.pipeDistance[0],
          gameOptions.pipeDistance[1]
        );
      this.pipePool[0].y = pipeHolePosition - pipeHoleHeight / 2;
      this.pipePool[0].setOrigin(0, 1);
      this.pipePool[1].x = this.pipePool[0].x;
      this.pipePool[1].y = pipeHolePosition + pipeHoleHeight / 2;
      this.pipePool[1].setOrigin(0, 0);
      this.pipePool = [];
      if (addScore) {
        this.updateScore(1);
      }
    }
    flap() {
      this.bird.body.velocity.y = -gameOptions.birdFlapPower;

      let fc = ctx.getState().f

      ctx.hydrate({ f: fc + 1 });
    }
    getRightmostPipe() {
      let rightmostPipe = 0;
      this.pipeGroup.getChildren().forEach(function (pipe) {
        rightmostPipe = Math.max(rightmostPipe, pipe.x);
      });
      return rightmostPipe;
    }
    update() {
      this.bird.anims.play("playerAnimation", true);

      this.physics.world.collide(
        this.bird,
        this.pipeGroup,
        function () {
          this.die();
        },
        null,
        this
      );
      if (this.bird.y > game.config.height - 60 || this.bird.y < 0) {
        this.die();
      }
      this.pipeGroup.getChildren().forEach(function (pipe) {
        if (pipe.getBounds().right < 0) {
          this.pipePool.push(pipe);
          if (this.pipePool.length == 2) {
            this.placePipes(true);
          }
        }
      }, this);

      if (this.ground.x <= -game.config.width) {
        this.ground.x = 0;
      }
    }
    die() {
      this.scene.start("EndScreen");

      ctx.emit("game", (state) => {
        return {
          game: "ended",
          score: this.score,
          highscore: userHighScore,
        };
      });
    }
  }

  let emailInput
  let nameInput

  // setup form
  on(submit, "click", (e) => {
    e.preventDefault();

    add(errorEmail, "hidden");

    nameInput = document.querySelector(".js-name").value;
    emailInput = document.querySelector(".js-email").value;
    // const legalCheckbox = document.querySelector(".js-legal").checked;

    if (!emailInput.includes("@")) {
      remove(errorEmail, "hidden");
      return;
    }

    //validate form fields
    if (!nameInput || !emailInput) {
      remove(error, "hidden");
    } else {
      add(error, "hidden");

      //save player info
      let player = { name: nameInput, email: emailInput };

      ctx.hydrate({ player: player });

      ctx.emit("game", { game: "created" });

      //klaviyo signup
      let listId = "SsYyQ7";

      if (emailInput.includes("@")) {
        subscribe(listId, emailInput, {
          $fields: ["Name", "T"],
          Name: nameInput
        }).then((response) => {});
      } else {
        remove(error, "hidden");
      }

      introScreen.remove();

      game.scene.start("StartScreen");
    }

    // introScreen.remove();

    //send game started gtag
    gtag("event", "login", {
      event_category: "Game",
      event_label: "User Logged In",
    });

    ttq.track("CompleteRegistration", {
      event_category: "Game",
      event_label: "User Logged In",
    });

    fbq("track", "login", {
      event_category: "Game",
      event_label: "User Logged In",
    });

    // game.scene.start("StartScreen");
  });

  on(restart, "click", () => {
    game.scene.start("StartScreen");
    ctx.emit("game", { game: "created" });

    //send game started gtag
    gtag("event", "level_restart", {
      event_category: "Game",
      event_label: "Game Restarted",
    });

    ttq.track("level_restart", {
      event_category: "Game",
      event_label: "Game Restarted",
    });

    fbq("track", "level_restart", {
      event_category: "Game",
      event_label: "Game Restarted",
    });
  });

  //game states
  const AIRTABLE_TOKEN = node.dataset.game;
  const AIRTABLE_BASE = "appqIF8HJEw3r0aTk";

  node.dataset.game = "";

  const base = new Airtable({
    apiKey: AIRTABLE_TOKEN,
  }).base(AIRTABLE_BASE);

  const createPlayer = (player, index, score) => {
    let stats = player.fields;
    let name;
    if (stats) {
      name = stats["Name"];
    }

    const div = document.createElement("div");
    div.className = "leaderboard-item flex justify-between w-full";

    // Customize the content based on your data structure
    div.innerHTML = `<div>${index + 1}. ${name}</div> <div>${score}</div>`;

    // Append the div to the container
    leaderboard.appendChild(div);
  };

  const fetchLeaderboard = (currentPlayer, highScore) => {
    //get leaderboard after updating
    // console.log("retrieving leaderboard...");
    base("Leaderboard")
      .select({
        maxRecords: 1000,
        view: "Grid view",
      })
      .eachPage(
        (records, fetchNextPage) => {
          // Check if there is a matching record
          if (records.length > 0) {
            // console.log("hydrating leaderboard...");
            ctx.hydrate({ leaderboard: records });
          }

          // Clear the container before rendering to avoid duplicates
          leaderboard.innerHTML = "";

          const currentPlace = records.findIndex(
            (item) => item.id === currentPlayer.id
          );

          // Loop through the leaderboard array and create HTML elements for each item
          records.forEach((player, index) => {
            const playerLimit = currentPlace > 4 ? 4 : 5;
            if (index < playerLimit) {
              createPlayer(player, index, player?.fields["Score"]);
            }
          });

          //render high score on leaderboard
          userScore.innerHTML = highScore;

          if (currentPlace > 4) {
            createPlayer(currentPlayer, parseInt(currentPlace), highScore);
          }
        },
        function done(err, records) {
          if (err) {
            console.error(err);
            return;
          }
        }
      );
  };

  ctx.on("game", () => {
    let gameState = ctx.getState().game;

    //get current player
    let player = ctx.getState().player;
    let searchValue;
    let filterByFormula;

    if (player) {
      searchValue = player?.email || "null@null.com";
      filterByFormula = `SEARCH("${searchValue}", {Email}) != ''`;
    }

    if (gameState == "intro") {
      remove(introScreen, "hidden");
      add(lander, "hidden");

      //send intro gtag
      gtag("event", "start_game_click", {
        event_category: "Game",
        event_label: "Game Started",
      });

      ttq.track("start_game_click", {
        event_category: "Game",
        event_label: "Game Started",
      });

      fbq("track", "start_game_click", {
        event_category: "Game",
        event_label: "Game Started",
      });
    } else if (gameState == "created") {
      add(killScreen, "hidden");
      game.scene.start("StartScreen");

      //check if user already exists
      // console.log("checking if user already exists...");
      base("Leaderboard")
        .select({
          filterByFormula: filterByFormula,
          view: "Grid view",
        })
        .eachPage(
          (records, fetchNextPage) => {
            // if(records?.find())
            // Check if there is a matching record
            if (records.length > 0) {
              ctx.hydrate({ highscore: records[0]?.fields["Score"] });
              userHighScore = records[0]?.fields["Score"];
            } else {
              // console.log("no user found");
            }
          },
          function done(err, records) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );

      //send intro gtag
      gtag("event", "level_start", {
        event_category: "Game",
        event_label: "Level Started",
      });

      ttq.track("level_start", {
        event_category: "Game",
        event_label: "Level Started",
      });

      fbq("track", "level_start", {
        event_category: "Game",
        event_label: "Level Started",
      });
    } else if (gameState == "started") {
    } else if (gameState == "ended") {
      //handle high score submission
      game.scene.start("EndScreen");
      remove(killScreen, "hidden");

      const highScore = ctx.getState().highscore;

      base("Leaderboard")
        .select({
          filterByFormula: filterByFormula,
          view: "Grid view",
        })
        .eachPage(
          (records, fetchNextPage) => {
            // if(records?.find())
            // Check if there is a matching record
            if (records?.length > 0) {
              let userHigh =
                userHighScore > highScore ? userHighScore : highScore || 0;

              let currentPlayer = records[0];
              // Use the 'update' method to update the record
              base("Leaderboard").update(
                [
                  {
                    id: records[0]?.id,
                    fields: {
                      Name: player.name,
                      Score:
                        userHighScore < highScore
                          ? highScore
                          : userHighScore || 0,
                    },
                  },
                ],
                function (err, records) {
                  if (err) {
                    console.error("Error updating record:", err);
                    return;
                  }

                  fetchLeaderboard(currentPlayer, userHigh);

                  // if (records && records.length > 0) {
                  //   console.log("Record updated successfully");
                  // } else {
                  //   console.error("No records updated.");
                  // }
                }
              );

              //send game started gtag
              gtag("event", "post_score", {
                event_category: "Game",
                event_label: "High Score Posted",
                value: userHigh,
              });

              ttq.track("post_score", {
                event_category: "Game",
                event_label: "High Score Posted",
                value: userHigh,
              });

              fbq("track", "post_score", {
                event_category: "Game",
                event_label: "High Score Posted",
                value: userHigh,
              });
            } else {
              console.log("no matching record found. creating new player...");
              base("Leaderboard").create(
                [
                  {
                    fields: {
                      Name: player.name,
                      Email: player.email,
                      Score: parseInt(highScore) || 0,
                    },
                  },
                ],
                function (err, records) {
                  if (err) {
                    console.error(err);
                    return;
                  }
                  base("Leaderboard")
                    .select({
                      filterByFormula: `SEARCH("${player.email}", {Email}) != ''`,
                      view: "Grid view",
                    })
                    .eachPage(
                      (records, fetchNextPage) => {
                        // if(records?.find())
                        // Check if there is a matching record
                        console.log("checking for a matching record...");
                        if (records?.length > 0) {
                          let currentPlayer = records[0];
                          // Use the 'update' method to update the record
                          fetchLeaderboard(currentPlayer, parseInt(highScore));
                        }
                      },
                      function done(err, records) {
                        if (err) {
                          console.error(err);
                          return;
                        }
                      }
                    );
                }
              );
            }
          },
          function done(err, records) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );

      if(sessionScore >= ctx.getState().highscore){
        var currentDate = new Date();
        subscribe(listId, ctx.getState().player?.email, {
          $fields: ["Name", "Score", "L", "T", "F"],
          Name: ctx.getState().player?.name,
          Score: ctx.getState().highscore,
          L: currentDate,
          T: ctx.getState().to,
          F: ctx.getState().f
        });
      } else{
        var currentDate = new Date();
        subscribe(listId, ctx.getState().player?.email, {
          $fields: ["Name", "Score", "L"],
          Name: ctx.getState().player?.name,
          Score: ctx.getState().highscore,
        });
      }
    }
  });

  //setup airtable
});
